import ShareIcon from '@mui/icons-material/Share';
import copy from 'copy-to-clipboard';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useLocation } from 'react-use';
import BannerImg from '../../../../public/assets/images/BannersFiles/31.jpg';
import { DataNotFound } from '../../../components/DataNotFound';
import LoadingAnimation from '../../../components/LoadingAnimation';
import LoaderModal from '../../../components/common/LoaderModal';
import CounterApp from '../../../components/counter/Counter';
import ModalCartSuccessful from '../../../components/elements/ModalCartSuccessfull';
import SMSModal from '../../../components/elements/SMSModal';
import StaticBanner from '../../../components/elements/StaticBanner';
import { getFromLocalStorage } from '../../../components/helper/authorizationHelper';
import baseURL, { getAsync, postAsync, reactURL } from '../../../components/helper/axiosHelper';
import { defaultImage } from '../../../constants';
import { updatedCart } from '../../../features/updatedCartSlice';
import { addToCart } from '../../../features/usercartSlice';
import { PageHitCountApi } from '../../../shared/Helper';
import { addMenuTitle } from '../../../features/MainMenuTitleSlice';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { RemoveShoppingCartRounded } from '@mui/icons-material';
const SadaqatDonation = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const Mainmenu = useSelector((state) => state.menuTitle.menuName);
  const [value, setValue] = useState([]);
  const [modalMessageText, setModalMessageText] = useState('');
  const [modalExist, setModalExist] = useState(false);
  const [gridModalOpen, setGridModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [epUserID, setEpUserID] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [amount, setAmount] = useState(0);
  const [count, setCount] = useState(1);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [previousIndex, setPreviousIndex] = useState(currentIndex);
  const [smsModal, setSmsModal] = useState(false);
  const [errorStates, setErrorStates] = useState([]);
  const [projectGuID, setprojectGuID] = useState('');
  const [selectedValues, setSelectedValues] = useState([]);
  const [paymentMethodId, setPaymentMethodId] = useState(1);
  const [projectId, setProjectId] = useState('');

  const { id } = useParams();
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const token = localStorage.getItem('token');
  const shouldHideIcon = location.pathname.includes('PaymentProcess');

  useEffect(() => {
    localStorage.setItem('isHome', true);
    const fetchData = async () => {
      setValue(null);
      setLoading(true);
      try {
        const response = await fetch(`${baseURL}/APIClient/InternalProjectSHJC?ModuleId=${id}`);

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const result = await response.json();
        setValue(result);

        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    if (id) {
      fetchData();
      PageHitCountApi(pathname, 0);
    }
  }, [id]);
  useEffect(() => {
    (async () => {
      const response = await getAsync('CMSMenu/GetCMSMenus');
      if (response?.data) {
        // setData(response.data);
        // Transform the data inside setData scope
        const updatedArray = response.data
          ?.flatMap((obj) => obj.childrens || [])
          ?.map((obj) => ({
            menuItemID: obj?.shjcApiID,
            ar_SA: obj?.ar_SA,
            en_US: obj?.en_US,
          }));

        if (updatedArray?.length) {
          dispatch(addMenuTitle(updatedArray));
        }
      }
    })();
  }, [dispatch]);

  useEffect(() => {
    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log('data', err);
      });
  }, [epUserID]);

  useEffect(() => {
    if (value?.data && value?.data?.length > 0) {
      setSelectedValues(Array(value?.data?.length).fill(1));
    }
  }, [value?.data]);

  const dataObject = {
    paymentMethodId: paymentMethodId,
    amount,
  };

  const updateErrorState = (index, isError) => {
    setErrorStates((prevStates) => {
      const newErrorStates = [...prevStates];
      newErrorStates[index] = isError;
      return newErrorStates;
    });
  };

  const DonateHandle = (currentIndex, i, id, price, referralLink, isContribution, projectTypeIdInt) => {
    // let selectedAmount = currentIndex !== i ? price : amount;
    let selectedAmount = currentIndex == i ? Number(amount) : 0;

    if (selectedAmount > 0) {
      if (selectedAmount == 0) {
        updateErrorState(isContribution, true);
        return;
      } else {
        updateErrorState(isContribution, false);
        const payload = {
          ...dataObject,
          amount: selectedAmount,
          isContribution,
        };
        const link = `/externalPayment/${id}/${referralLink}/10/${projectTypeIdInt}`;
        navigate(link, { state: { paymentInfo: payload } });
      }
    } else {
      toast.error(`${t('Amount must be greater than 0')}`);
    }
  };
  if (loading) return <LoadingAnimation imageStyling={''} styling={'h-screen'} />;

  const addCartItem = async (currentIndex, i, price, pId, projectTypeIdInt) => {
    try {
      // let selectedAmount = currentIndex !== i ? price : amount;
      let selectedAmount = currentIndex == i ? Number(amount) : 0;
      if (selectedAmount > 0) {
        if (selectedAmount !== 0) {
          setIsLoading(true);
          const res = await postAsync(`Cart/GetCartListByEpUserIdAndIP`, { EPUserID: epUserID });
          dispatch(addToCart(res?.data));
          const response = await postAsync(`APIClient/ProjectListGUID`, [
            { ProjectId: pId, ProjectTypeIdInt: projectTypeIdInt },
          ]);
          // if (response.statusCode) {
          //   setModalMessageText('Item not added in cart');
          //   setModalExist(true);
          //   setGridModalOpen(true);
          // }
          if (response) {
            setIsLoading(false);
          }
          const newItem = response?.data;
          const cartbody = {
            cartID: 0,
            projectName: newItem[0]?.titleAr || newItem[0]?.titleEn,
            epUserID: epUserID,
            ip: 'string',
            projectID: newItem[0]?.id,
            amount: selectedAmount,
            projectTypeIdInt,
          };
          if (token && res?.statusCode === 204) {
            await postAsync(`Cart/CreateCart`, cartbody);
            const resp = await postAsync(`Cart/GetCartListByEpUserIdAndIP`, { EPUserID: epUserID });
            dispatch(addToCart(resp?.data));
            dispatch(updatedCart(true));
            setModalMessageText('Add to cart Successfully');
            setModalExist(false);
            setGridModalOpen(true);
            return;
          } else if (res.data?.length && res?.statusCode === 200) {
            const itemExistsdatabase = res?.data?.some((item) => item.projectID === pId);
            if (token && !itemExistsdatabase) {
              await postAsync(`Cart/CreateCart`, cartbody);
              const respo = await postAsync(`Cart/GetCartListByEpUserIdAndIP`, {
                EPUserID: epUserID,
              });
              dispatch(addToCart(respo?.data));
              dispatch(updatedCart(true));
              setModalMessageText('Add to cart Successfully');
              setModalExist(false);
              setGridModalOpen(true);
            } else {
              setModalMessageText('Item  Already Exists');
              setModalExist(true);
              setGridModalOpen(true);
            }
          }
          if (!token) {
            const updateCart = (data) => {
              const updatedData = data.map((item) => {
                if (item?.id === newItem[0].id) {
                  return { ...item, price: selectedAmount };
                }
                return item;
              });
              localStorage.setItem('cart', JSON.stringify(updatedData));
            };

            const existingData = JSON.parse(localStorage.getItem('cart')) || [];

            const itemExists = existingData.some((item) => item?.id === newItem[0]?.id);
            if (itemExists) {
              setModalMessageText('Item  Already Exists');
              setModalExist(true);
              setGridModalOpen(true);
              updateCart(existingData);
            } else {
              dispatch(updatedCart(true));
              newItem[0].price = selectedAmount;
              updateCart([...existingData, ...newItem]);
              setModalMessageText('Add to cart Successfully');
              setModalExist(false);
              setGridModalOpen(true);
            }
          }
        } else {
          setprojectGuID(pId);
        }
      } else {
        toast.error(`${t('Amount must be greater than 0')}`);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleShareLink = (guid, projectTypeIdInt) => {
    setIsLoading(true);
    const shareLink = `${reactURL}/PaymentProcess/` + guid + '/' + guid + '/' + 10 + '/' + projectTypeIdInt;
    copy(shareLink);
    toast.success(t('Link copy Successfully'));
    setIsLoading(false);
  };

  const handleOnChange = (index, value) => {
    const newSelectedValues = [...selectedValues];
    newSelectedValues[index] = value;
    setSelectedValues(newSelectedValues);
    setPaymentMethodId(value);
  };

  return (
    <div className="">
      {/* {Mainmenu?.map((data) => {
        if (data?.menuItemID == +id) {
          return <StaticBanner BannerImg={BannerImg} ar_SA={data?.ar_SA} en_US={data?.en_US} arabic={true} />;
        }
      })} */}
      {+id === 22
        ? (() => {
            const data = Mainmenu.find((item) => item.menuItemID === 22 && item.en_US === 'General Charity');

            if (data) {
              return (
                <StaticBanner
                  BannerImg={'/assets/images/BannersFiles/31.jpg'}
                  ar_SA={data.ar_SA}
                  en_US={data.en_US}
                  arabic={true}
                />
              );
            }

            return null;
          })()
        : Mainmenu?.map((data) => {
            if (data?.menuItemID == +id) {
              return (
                <StaticBanner
                  BannerImg={'/assets/images/BannersFiles/31.jpg'}
                  ar_SA={data?.ar_SA}
                  en_US={data?.en_US}
                  arabic={true}
                />
              );
            }
            return null;
          })}
      <div className="container-fluid py-5 justify-center">
        <div className="row px-4 sm:px-5 md:px-5 lg:px-5  justify-center">
          {value?.data?.length > 0 ? (
            value?.data?.map((data, i) => {
              return (
                <>
                  <div
                    key={i + 1}
                    data-aos="zoom-in"
                    data-aos-once="true"
                    className="bg-white border m-1 w-96 my-3 border-gray-200 rounded-3xl shadow  px-3"
                  >
                    <div className="py-1 justify-center hover:scale-105 transition-transform duration-300 ">
                      <div className={` flex justify-between text-center  ${isActive ? 'pl-12' : 'pr-12'}`}>
                        {!shouldHideIcon && (
                          <ShareIcon
                            onClick={() => handleShareLink(data?.id, data?.projectTypeIdInt)}
                            className={`w-7 h-7 items-center cursor-pointer text-customgreen hover:text-hovergreen m-3 transition-colors duration-700 ${
                              isActive ? 'rotate-180' : ''
                            }`}
                          />
                        )}
                        <div className={`flex   justify-center items-center  w-full ${shouldHideIcon && 'mt-3'} `}>
                          {/* <h3 className="capitalize truncate text-wrap font-semibold text-customgreen">
                            {data?.title_AR &&
                              t(
                                isActive
                                  ? data?.title_AR?.length > 15
                                    ? `${data?.title_AR.slice(0, 15)}...`
                                    : data?.title_AR
                                  : data?.title_EN?.length > 15
                                    ? `${data?.title_EN.slice(0, 15)}...`
                                    : data?.title_EN,
                              )}
                          </h3> */}
                          {data?.title_AR && (
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="tooltip-title" className="custom-tooltip">
                                  {t(isActive ? data?.title_AR : data?.title_EN)}
                                </Tooltip>
                              }
                            >
                              <h3 className="capitalize truncate text-wrap font-semibold text-customgreen">
                                {t(
                                  isActive
                                    ? data?.title_AR?.length > 15
                                      ? `${data?.title_AR.slice(0, 15)}...`
                                      : data?.title_AR
                                    : data?.title_EN?.length > 15
                                      ? `${data?.title_EN.slice(0, 15)}...`
                                      : data?.title_EN,
                                )}
                              </h3>
                            </OverlayTrigger>
                          )}
                        </div>
                      </div>

                      {
                        <img
                          className="w-full h-32 mx-auto rounded-t-2xl"
                          src={`data:image/jpeg;base64,
                              ${data?.file_Stream || data?.picture ? data?.file_Stream || data?.picture : defaultImage}`}
                          alt="project Name"
                        />
                      }

                      {data?.isContribution === true && id != 22 && (
                        <div className="relative w-full mx-auto h-6 bg-gray-200 ">
                          <div
                            className={`absolute top-0 ${isActive ? 'right-0' : 'left-0'} h-full text-center   ${data?.receivedPercentage === 0 ? ' text-black' : 'text-white'} bg-customgreen `}
                            style={{ width: `${data?.receivedPercentage}%` }}
                          >
                            {data?.receivedPercentage}%
                          </div>
                        </div>
                      )}

                      <div className="">
                        <h5 className="md:my-3 my-2 text-md text-center text-sm font-bold tracking-tight text-gray-900 ">
                          {t('Total Cost')} <span className="mx-2">:</span>
                          <span className={`${isActive ? 'ml-2' : 'mr-2'} text-customorange font-bold`}>
                            {data?.price || '0'}
                          </span>
                          <span className={`${isActive ? 'ml-2' : 'mr-2'} font-bold`}>{t('AED')}</span>
                        </h5>
                        <p className="my-3 px-2 lg:px-3 text-sm text-center truncate  tracking-tight text-gray-900 ">
                          {isActive
                            ? data?.details_AR || data?.descriptionAr
                            : data?.details_EN || data?.descriptionEnglish}
                        </p>

                        <div
                          className={`flex items-center pb-3 justify-around flex-col-reverse md:flex-row-reverse space-x-1 ${data?.isContribution != null && data?.isContribution === true ? 'mt-0' : 'mt-8'}`}
                        ></div>

                        <div className={`space-y-4 ${data?.isAltakamul ? '' : 'pb-3'}`}>
                          {data?.isRecurring && (
                            <div className="flex gap-3 justify-between">
                              {/* One Time Payment Radio Button */}
                              <div
                                onClick={() => handleOnChange(i, 1)}
                                className={`w-full cursor-pointer flex items-center border-2 ${
                                  selectedValues[i] === 1
                                    ? 'border-customgreen dark:border-customgreen bg-green-50 shadow-md'
                                    : 'border-gray-200'
                                } rounded-full dark:border-gray-700 p-2`}
                              >
                                <input
                                  onChange={(e) => {
                                    handleOnChange(i, 1);
                                  }}
                                  id={`bordered-radio-1-${i}`}
                                  type="radio"
                                  value={1}
                                  name={`payment-${i}`}
                                  className="text-customgreen text-sm cursor-pointer rounded-lg focus:ring-customgreen focus:border-customgreen block"
                                  checked={selectedValues[i] === 1} // Use checked for controlled input
                                />
                                <label
                                  htmlFor={`bordered-radio-1-${i}`}
                                  className="w-full ms-2 text-sm cursor-pointer font-medium"
                                >
                                  {t('One Time')}
                                </label>
                              </div>

                              {/* Monthly Payment Radio Button */}
                              <div
                                onClick={() => handleOnChange(i, 2)}
                                className={`w-full cursor-pointer flex items-center border-2 ${
                                  selectedValues[i] === 2
                                    ? 'border-customgreen dark:border-customgreen bg-green-50 shadow-md'
                                    : 'border-gray-200'
                                } rounded-full dark:border-gray-700 p-2`}
                              >
                                <input
                                  onChange={(e) => {
                                    handleOnChange(i, 2);
                                  }}
                                  id={`bordered-radio-2-${i}`}
                                  type="radio"
                                  value={2}
                                  name={`payment-${i}`}
                                  className="text-customgreen text-sm cursor-pointer rounded-lg focus:ring-customgreen focus:border-customgreen block"
                                  checked={selectedValues[i] === 2} // Use checked for controlled input
                                />
                                <label
                                  htmlFor={`bordered-radio-2-${i}`}
                                  className="w-full ms-2 text-sm cursor-pointer font-medium"
                                >
                                  {t('Monthly')}
                                </label>
                              </div>
                            </div>
                          )}
                          <div className="flex flex-col sxx:flex-row-reverse sm:flex-row-reverse md:flex-row-reverse lg:flex-row-reverse xl:flex-row-reverse items-center justify-around gap-4 ">
                            <div className=" w-full">
                              <input
                                id={`amount-${i + 1}`}
                                name={`amount-${i}`}
                                type="text"
                                value={
                                  previousIndex === i ? amount : 0

                                  // previousIndex === i
                                  //   ? amount || data.amount
                                  //   : data.totalCost || data.price || data.amount
                                }
                                onInput={(event) => {
                                  const { name, value } = event.target;
                                  const regex = /^(0|[1-9]\d*)(\.\d{1,2})?$/;

                                  if (regex.test(value) || value === '') {
                                    setPreviousIndex(i);
                                    setCurrentIndex(i);
                                    setAmount(value);
                                  } else {
                                    event.target.value = value.replace(/\D/g, '');
                                  }
                                }}
                                className={`${data?.isContribution == false && 'bg-gray-200 cursor-not-allowed'}   w-full focus:border-customgreen border border-customgreen focus:ring-2 focus:ring-customgreen rounded-full`}
                                placeholder={t('Enter Amount')}
                                maxLength={7}
                                min="0"
                                disabled={data?.isContribution == false}
                              />
                            </div>
                            {data?.isCounter && (
                              <div className="w-full">
                                <CounterApp
                                  index={i}
                                  previousIndex={previousIndex}
                                  setPreviousIndex={setPreviousIndex}
                                  currentIndex={currentIndex}
                                  setCurrentIndex={setCurrentIndex}
                                  count={count}
                                  setCount={setCount}
                                  amount={amount}
                                  setAmount={setAmount}
                                  price={data.price}
                                />
                              </div>
                            )}
                          </div>

                          <p className="text-red-900 text-center">
                            {errorStates[i] && 'Amount Must be Greater Than 0'}
                          </p>

                          <div className="flex flex-col sxx:flex-row sm:flex-row md:flex-row lg:flex-row xl:flex-row items-center justify-around gap-3 ">
                            <button
                              className="w-full text-center text-white border border-white bg-customgreen hover:bg-hovergreen hover:text-white focus:ring-4 focus:outline-none focus:ring-customgreen font-medium rounded-full text-lg p-1.5 flex justify-center items-center transition duration-700 ease-in-out "
                              onClick={() => {
                                DonateHandle(
                                  currentIndex,
                                  i,
                                  data?.id,
                                  data.price || data.totalCost || data.amount,
                                  data?.id,
                                  data?.isContribution,
                                  data?.projectTypeIdInt,
                                );
                                data?.isContribution &&
                                  setAmount(data?.isContribution ? data?.price || data?.totalCost : null);
                              }}
                            >
                              {t('Donate Now')}{' '}
                            </button>
                            <button
                              disabled={isLoading ? true : false}
                              onClick={() => {
                                addCartItem(
                                  currentIndex,
                                  i,
                                  data.price || data.totalCost || data.amount,
                                  data?.id,
                                  data?.projectTypeIdInt,
                                  '6',
                                );
                                data?.isContribution &&
                                  setAmount(data?.isContribution ? data?.price || data.totalCost : null);
                              }}
                              type="button"
                              className="w-full text-center text-white border border-white bg-customgreen hover:bg-hovergreen hover:text-white focus:ring-4 focus:outline-none focus:ring-customgreen font-medium rounded-full text-lg p-2 flex justify-center items-center transition duration-700 ease-in-out"
                            >
                              <svg
                                className="w-6 h-6"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path d="M10 20.5c0 .829-.672 1.5-1.5 1.5s-1.5-.671-1.5-1.5c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5zm3.5-1.5c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5 1.5-.671 1.5-1.5c0-.828-.672-1.5-1.5-1.5zm6.304-17l-3.431 14h-2.102l2.541-11h-16.812l4.615 13h13.239l3.474-14h2.178l.494-2h-4.196z" />
                              </svg>

                              <span className="sr-only">Icon description</span>
                            </button>
                          </div>

                          {data?.isAltakamul && (
                            <div className="w-full pb-3">
                              <button
                                className="w-full text-center text-white border border-white bg-customgreen hover:bg-hovergreen hover:text-white focus:ring-4 focus:outline-none focus:ring-customgreen font-medium rounded-full text-lg p-1.5 flex justify-center items-center uppercase transition duration-700 ease-in-out"
                                onClick={() => {
                                  setProjectId(data?.id);
                                  setSmsModal(true);
                                }}
                              >
                                {t('sms')}
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            })
          ) : (
            <>
              <DataNotFound />
            </>
          )}
          {
            <ModalCartSuccessful
              modalMessageText={modalMessageText}
              modalExist={modalExist}
              setGridModalOpen={setGridModalOpen}
              gridModalOpen={gridModalOpen}
            />
          }
          {<SMSModal smsModal={smsModal} setSmsModal={setSmsModal} projectId={projectId} />}
          {isLoading && <LoaderModal />}
        </div>
      </div>
    </div>
  );
};

export default SadaqatDonation;
